export default __webpack_public_path__ + "static/media/people_karier.c6367b4d.png";